import { notification } from "antd";
import { journalsServiceApi } from "@entities/api";
import { NOTIFICATION_MESSAGES } from "@shared/utils";

interface IUpdateSectionTwoRecordSigned {
  sectionTwoListId: string;
  versionId: string;
  updateSectionTwoRequest: {
    mainJournalId: string;
    section2Id: string;
    section2ListId: string;
    specialJournalName: string;
    specialJournalDate: string;
    journalKeepersList?: Array<any>;
    dateHandover?: string | null;
    signer: string;
  };
  actionDetails: string;
  file?:
    | { file?: File | null | undefined; id?: string | null | undefined }
    | null
    | undefined;
}

export async function updateSectionTwoRecordSigned({
  sectionTwoListId,
  versionId,
  updateSectionTwoRequest,
  actionDetails,
  file,
}: IUpdateSectionTwoRecordSigned) {
  if (!versionId || versionId.toString().trim().length === 0) {
    notification.error({
      message: NOTIFICATION_MESSAGES.ERROR, // "Ошибка"
      description: NOTIFICATION_MESSAGES.SAVE_VERSION_NOT_FOUND_ERROR_DESC, // "Не удалось определить версию подписанной записи. Обновите страницу и попробуйте снова."
      placement: "topRight",
    });
    throw new Error("missing_version_id");
  }

  const formData = new FormData();

  // JSON part for updateSectionTwoRequest (must match Swagger model exactly)
  formData.append(
    "updateSectionTwoRequest",
    new Blob([JSON.stringify(updateSectionTwoRequest)], {
      type: "application/json",
    }),
  );

  // actionDetails should be at the root level of form-data, not inside updateSectionTwoRequest
  if (typeof actionDetails === "string") {
    formData.append("actionDetails", actionDetails);
  }

  // File should be a separate part, not nested inside JSON
  if (file?.file) {
    formData.append("file", file.file);
    formData.append(
      "fileMetadata",
      new Blob(
        [
          JSON.stringify({
            fileNumber: 1,
            fileName: file.file.name,
            fileType: file.file.type,
            fileContentLength: file.file.size,
          }),
        ],
        { type: "application/json" },
      ),
    );
  }

  // Debug logs of what and where we're sending
  /* eslint-disable no-console */
  try {
    const jsonBlob = formData.get(
      "updateSectionTwoRequest",
    ) as Blob | null;
    if (jsonBlob) {
      const jsonText = await jsonBlob.text();
      try {
        console.log("\u2705 Section-2 SIGNED update JSON:", JSON.parse(jsonText));
      } catch (e) {
        console.log("\u26A0\uFE0F Could not parse JSON blob:", jsonText);
      }
    }
    const reason = formData.get("actionDetails");
    if (reason) {
      console.log("\u2705 Section-2 SIGNED update actionDetails:", reason);
    }
    if (file?.file) {
      console.log("\u2705 Section-2 SIGNED update file:", {
        name: file.file.name,
        size: file.file.size,
        type: file.file.type,
      });
      const metaBlob = formData.get("fileMetadata") as Blob | null;
      if (metaBlob) {
        const metaText = await metaBlob.text();
        try {
          console.log("\u2705 Section-2 SIGNED update fileMetadata:", JSON.parse(metaText));
        } catch (e) {
          console.log("\u26A0\uFE0F Could not parse fileMetadata:", metaText);
        }
      }
    }
  } catch {
    (() => {})();
  }

  const url = `/journals/section-two/${sectionTwoListId}/items/${versionId}/update`;
  console.log("\u27A1\uFE0F PUT", url);
  /* eslint-enable no-console */

  const response = await journalsServiceApi.putForm(url, formData);

  return response.data;
}
